<template>
  <div style="height: 100%">
    <div v-if="isAudioBarFirstShow" class="closeTip">
      <div class="closeTipBox">
        向左滑动关闭哦~
      </div>
    </div>
    <div
      :class="['audioBarWrapper', isLeftSlide ? 'audioBarWrapperLeft' : '']"
      @click="handleDetail"
      @touchstart="handleDeleteStart"
      @touchmove="handleDeleteMove"
      @mousedown="handlePcDeleteStart"
    >
      <div :class="[isLeftSlide ? 'left' : '']">
        <div class="audioInfo">
          <div class="cover">
            <img :src="audioList[audioCurrentIndex].cover" alt="频道封面" />
          </div>

          <my-marquee
            v-if="audioList[audioCurrentIndex].name.length > 12"
            :text="audioList[audioCurrentIndex].name"
            styleType="titleMarquee"
            class="title"
          ></my-marquee>
          <div class="title" v-else>
            {{ audioList[audioCurrentIndex].name }}
          </div>

          <div class="play" @click.capture.stop="handlePlay">
            <div v-if="isPlay">
              <!-- <img src="~@/assets/img/pauseAudio.png" alt="暂停" /> -->
            </div>
            <div v-else>
              <!-- <img src="~@/assets/img/playAudio.png" alt="开始" /> -->
            </div>
          </div>
        </div>

        <div
          v-if="!isPC"
          class="slider"
          @click.capture.stop=""
          @touchstart.capture.stop="handleTouchStart"
          @touchmove.capture.stop="handleTouchMove"
          @touchend.capture.stop="handleTouchEnd"
          ref="track"
        >
          <div class="slider-track"></div>
          <div class="slider-fill" :style="{ width: `${progress}%` }"></div>
          <div class="slider-thumb" :style="{ left: `${progress}%` }"></div>
        </div>
        <div
          v-else
          class="slider"
          @click.capture.stop=""
          @mousedown.capture.stop="handleMouseDown"
          ref="pcTrack"
        >
          <div class="slider-track"></div>
          <div class="slider-fill" :style="{ width: `${progress}%` }"></div>
          <div class="slider-thumb" :style="{ left: `${progress}%` }"></div>
        </div>
      </div>
      <div class="close" v-if="isLeftSlide" @click.capture.stop="onCloseAudio">
        关闭
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
import { audioDetailTemplate } from "@/utils/utils";
import MyMarquee from "@/components/Use/my-marquee";

export default {
  name: "AudioBar",
  data() {
    return {
      currentTime: 0,
      progress: 0,
      isPlay: true,
      startX: 0,
      isLeftSlide: false,
      isPcDrag: false,
    };
  },
  created() {
    this.fPlayer.addEventListener("ended", this.timeEnded);
    this.fPlayer.addEventListener("timeupdate", this.timeUpdate);
    this.fPlayer.currentTime = this.audioCurrentTime;

    if (this.AutoplayIng) {
      // 表示这在播放
      this.setPause(true);
      this.isPlay = false;
      this.fPlayer.pause();
    } else {
      this.setPause(false);
      this.fPlayer.play();
    }
  },
  mounted() {},
  beforeDestroy() {
    this.fPlayer.removeEventListener("timeupdate", this.timeUpdate);
    this.fPlayer.removeEventListener("ended", this.timeEnded);
    this.fPlayer.pause();
    this.setPause(true);
  },
  destroyed() {
    this.setAudioBarFirstShow(false);
  },
  components: { MyMarquee },
  computed: {
    ...mapState(["isPC", "isPlayAudio", "chatLoading", "AutoplayIng","isToSpeakIng"]),
    ...mapState("audio", [
      "fPlayer",
      "audioList",
      "audioCurrentIndex",
      "audioCurrentTime",
      "isAudioBarFirstShow",
      "duration",
    ]),
  },
  watch: {
    isPlayAudio(val) {
      if (val) {
        this.isPlay = false;
        this.fPlayer.pause();
      } else {
        this.isPlay = true;
        this.fPlayer.play();
      }
    },
    AutoplayIng(val) {
      // 小封自动播报暂停

      if (val) {
        this.isPlay = false;
        this.fPlayer.pause();
      } else {
        if (!this.isPlayAudio) {
          this.isPlay = true;
          this.fPlayer.play();
        }
      }
    },
     isToSpeakIng(val){
      // 路由时，停止播放
      console.log("是否在说话呢？===",val)
        if (val) {
        this.isPlay = false;
        this.fPlayer.pause();
      } else {
        if (!this.isPlayAudio&&!this.AutoplayIng) {
          this.isPlay = true;
          this.fPlayer.play();
        }
      }
    }
  },
  methods: {
    ...mapMutations(["contactDisData", "setAudioBarShow"]),
    ...mapMutations("audio", [
      "setAudioCurrentIndex",
      "setAudioCurrentTime",
      "setAudioList",
      "setAudioBarFirstShow",
      "setDuration",
      "setPause",
    ]),
    ...mapActions(["asyncEnterAudio"]),
    init() {
      // 监听audio是否加载完毕，如果加载完毕，则读取audio播放时间

      this.getDuration();
      this.fPlayer.currentTime = this.audioCurrentTime;
      this.fPlayer.play();
      this.fPlayer.removeEventListener("canplay", this.init, false);
    },
    getDuration() {
      this.setDuration(this.fPlayer.duration);
    },
    timeUpdate(e) {
      this.setAudioCurrentTime(e.target.currentTime);
      if (this.duration != 0) {
        this.progress =
          this.audioCurrentTime <= this.duration
            ? (this.audioCurrentTime / this.duration) * 100
            : 100;
      } else {
        this.progress = 0;
      }
    },
    timeEnded() {
      this.handleNextAudio();
    },
    handlePlay() {
      this.isPlay = !this.isPlay;
      this.isPlay ? this.fPlayer.play() : this.fPlayer.pause();
    },
    handleNextAudio() {
      const length = this.audioList.length;
      this.setAudioCurrentIndex((this.audioCurrentIndex + 1) % length);
      this.fPlayer.setAttribute(
        "src",
        this.audioList[this.audioCurrentIndex].url
      );
      this.fPlayer.addEventListener("canplay", this.init, false);
      this.progress = 0;
      this.setAudioCurrentTime(0);
      this.isPlay = true;
      this.fPlayer.play();
    },
    onCloseAudio() {
      this.fPlayer.pause();
      setTimeout(() => {
        this.setAudioBarShow(false);
        this.setAudioCurrentIndex(-1);
        this.setAudioCurrentTime(0);
        this.setAudioList([]);
      }, 10);
    },
    handleDetail() {
      if (!this.isPcDrag && !this.chatLoading) {
        let audioTemplate = audioDetailTemplate(
          this.audioList,
          this.audioList[this.audioCurrentIndex].name
        );
        this.contactDisData([{ content: { right: true, tips: "音频详情" } }]);
        this.asyncEnterAudio();
        this.setAudioBarShow(false);
        this.contactDisData(audioTemplate);
      }
    },
    handleMouseDown(e) {
      this.fPlayer.play();
      this.isPlay = true;
      this.isPcDrag = true;
      document.addEventListener("mousemove", this.handleMouseMove);
      document.addEventListener("mouseup", this.handleMouseEnd);
    },
    handleMouseMove(e) {
      this.isPcDrag = true;
      this.fPlayer.pause();
      this.setPcMoveValue(e);
    },
    handleMouseEnd(e) {
      this.isPlay = true;
      this.fPlayer.play();
      this.setPcValue(e);
      document.removeEventListener("mousemove", this.handleMouseMove);
      document.removeEventListener("mouseup", this.handleMouseEnd);
      setTimeout(() => {
        this.isPcDrag = false;
      }, 10);
    },
    handleTouchStart(e) {
      this.fPlayer.play();
      this.isPlay = true;
    },
    handleTouchMove(e) {
      this.fPlayer.pause();
      this.setMoveValue(e.changedTouches[0]);
    },
    handleTouchEnd(e) {
      this.isPlay = true;
      this.fPlayer.play();
      this.setValue(e.changedTouches[0]);
    },
    setValue(e) {
      let currentTime =
        ((e.clientX - this.$refs.track.getBoundingClientRect().left) /
          this.$refs.track.clientWidth) *
        this.duration;
      this.setAudioCurrentTime(currentTime);
      this.fPlayer.currentTime = this.audioCurrentTime;
    },
    setMoveValue(e) {
      let progress =
        ((e.clientX - this.$refs.track.getBoundingClientRect().left) /
          this.$refs.track.clientWidth) *
        100;
      this.progress = progress > 100 ? 100 : progress < 0 ? 0 : progress;
      this.setAudioCurrentTime((this.progress * this.duration) / 100);
    },
    setPcValue(e) {
      let currentTime =
        ((e.clientX - this.$refs.pcTrack.getBoundingClientRect().left) /
          this.$refs.pcTrack.clientWidth) *
        this.duration;
      this.setAudioCurrentTime(currentTime);
      this.fPlayer.currentTime = this.audioCurrentTime;
    },
    setPcMoveValue(e) {
      let progress =
        ((e.clientX - this.$refs.pcTrack.getBoundingClientRect().left) /
          this.$refs.pcTrack.clientWidth) *
        100;
      this.progress = progress > 100 ? 100 : progress < 0 ? 0 : progress;
      this.setAudioCurrentTime((this.progress * this.duration) / 100);
    },

    handleDeleteStart(e) {
      this.startX = e.changedTouches[0].clientX;
    },
    handlePcDeleteStart(e) {
      if (this.isPC) {
        this.startX = e.clientX;
        document.addEventListener("mousemove", this.handlePcDeleteMove);
        document.addEventListener("mouseup", this.handlePcDeleteEnd);
      }
    },
    handleDeleteMove(e) {
      if (e.changedTouches[0].clientX - this.startX < 0) {
        this.isLeftSlide = true;
      }
      if (e.changedTouches[0].clientX - this.startX > 0) {
        this.isLeftSlide = false;
      }
    },
    handlePcDeleteMove(e) {
      this.isPcDrag = true;
      if (e.clientX - this.startX < 0) {
        this.isLeftSlide = true;
      }
      if (e.clientX - this.startX > 0) {
        this.isLeftSlide = false;
      }
    },
    handlePcDeleteEnd() {
      setTimeout(() => {
        this.isPcDrag = false;
      }, 10);
      document.removeEventListener("mousemove", this.handlePcDeleteMove);
      document.removeEventListener("mouseup", this.handlePcDeleteEnd);
    },
  },
};
</script>

<style lang="less" scoped>
.closeTip {
  position: absolute;
  top: -1.1rem;
  right: 0;
  width: 3.57rem;
  .closeTipBox {
    width: 3.57rem;
    height: 0.85rem;
    background-color: #a2b4ff;
    border-radius: 1.5rem 0 1.5rem 1.5rem;
    padding: 0.26rem 0.42rem;
    font-size: 0.32rem;
    color: #fff;
    line-height: 100%;
    box-sizing: border-box;
  }
}
.audioBarWrapperLeft {
  width: calc(100% + 1.92rem);
}
.audioBarWrapper {
  overflow: hidden;
  display: flex;
  height: 100%;
  .left {
    transform: translateX(-1.65rem);
  }

  .audioInfo {
    margin: 0.26rem 0.3rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .cover {
      width: 0.77rem;
      height: 0.77rem;
      border-radius: 0.13rem;
    }
    .title {
      width: 6rem;
      font-size: 0.43rem;
      font-weight: 600;
      line-height: 0.45rem;
      font-family: PingFangSC-Medium, PingFang SC;
      margin: 0 0.29rem 0.16rem;
    }
    .titleMarquee {
      width: 6rem;
      margin: 0 0.29rem;
    }
    .play {
      width: 0.69rem;
      height: 0.69rem;
    }
  }
  .slider {
    width: 8.05rem;
    position: relative;
    height: 0.05rem;
    display: flex;
    margin: 0.26rem 0.3rem;
    align-items: center;
    cursor: default;
    border-radius: 0.3rem;
    user-select: none;
    outline: none;
    .slider-track {
      position: absolute;
      height: 0.1rem;
      left: 0;
      right: 0;
      border-radius: 0.3rem;
      top: 50%;
      background-color: #dfe8fd;
      width: 8.05rem;
    }

    .slider-fill {
      position: absolute;
      height: 0.1rem;
      width: 100%;
      background-color: #376df6;
      left: 0;
      border-radius: 0.3rem;
      top: 50%;
      margin-top: -1px;
    }

    .slider-thumb {
      position: absolute;
      width: 0.21rem;
      top: 0.05rem;
      height: 0.21rem;
      background-color: #376df6;
      color: #ffbb38;
      border-radius: 50%;
      transform: translate(-50%, -50%);
      cursor: pointer;
    }
  }
  .close {
    width: 1.65rem;
    background-color: #ec6060;
    transform: translateX(-1.65rem);
    margin-left: 0.27rem;
    border-top-right-radius: 0.2rem;

    font-size: 0.37rem;
    color: #ffffff;
    line-height: 1.27rem;
    text-align: center;
  }
}
</style>
